<app-layout-loading [backgroundColor]="ColorsConstants.SURFACE_DARK" [showLoading]="isLoading | async">
  <section>
    <app-dashboard-filters (filterChanged)="onDashboardFilterChanged($event)" [searchKey]="'filter'"></app-dashboard-filters>
    <app-statistics-chart-section [cardsData]="statistics?.totals" [filters]="filter"></app-statistics-chart-section>
    <div class="cards">
      <ng-container *ngFor="let card of statisticsCardData">
        <app-statistics-card
          [cardHeaderLabel]="card?.cardHeaderLabel"
          [percentage]="card?.percentage"
          [statisticsLabel]="card?.statisticsLabel"
          [statisticsPercent]="card?.statisticsPercent"
        ></app-statistics-card>
      </ng-container>
    </div>
  </section>
</app-layout-loading>
<app-layout-loading [backgroundColor]="ColorsConstants.SURFACE_DARK" [showLoading]="isCommentsLoading | async " >
  <section>
    <app-comments-list [comments]="comments"></app-comments-list>
  </section>
</app-layout-loading>
